import React,{ useEffect,useState } from 'react';
import { getAdvisorAverageRating } from "../shared/_services/common.services";



const AdvisorReviewsCard = () => {
  const [ratingData, setRatingData] = useState(null);
  const STARS = [1, 2, 3, 4, 5];
  const fetchRatingData = async () => {
    try {
      const response = await getAdvisorAverageRating(JSON.parse(localStorage.getItem('currentUser'))?.user?._id);
      setRatingData(response?.data);
    } catch (error) {
      console.error('Error fetching rating data:', error);
    }
  };

  useEffect(() => {
    fetchRatingData();
  }, []);

  return (
    <div className='AdvisorReviewsCard'>
      <div className="row">
        <div className="col-7">
          <div className='d-flex place-items-center gap-10 mt-2 mb-3'><b>5</b><i className="fa fa-star"></i>
            <div className='progress-bar'><div style={{ width: "80%" }} className='progress'></div></div>
          </div>
          <div className='d-flex place-items-center gap-10 mb-3'><b>4</b><i className="fa fa-star"></i>
            <div className='progress-bar'><div style={{ width: "60%" }} className='progress'></div></div>
          </div>
          <div className='d-flex place-items-center gap-10 mb-3'><b>3</b><i className="fa fa-star"></i>
            <div className='progress-bar'><div style={{ width: "40%" }} className='progress'></div></div>
          </div>
          <div className='d-flex place-items-center gap-10 mb-3'><b>2</b><i className="fa fa-star"></i>
            <div className='progress-bar'><div style={{ width: "20%" }} className='progress'></div></div>
          </div>
          <div className='d-flex place-items-center gap-10 mb-3'><b>1</b><i className="fa fa-star"></i>
            <div className='progress-bar'><div style={{ width: "10%" }} className='progress'></div></div>
          </div>
        </div>
        <div className="col-5 place-content-center">
          <h2 className='text-right overall-rating'>{ratingData?.averageRating}.0</h2>
          <div className="ratings-stars text-right">
            {STARS.map((star) => (
              <i
                key={star}
                className={`fa fa-star${star <= Math.floor(ratingData?.averageRating ?? 0) ? '' : '-o'
                  }`}
              />
            ))}
          </div>
          <h6 className='text-light text-right mt-3'>{ratingData?.reviewsCount} Reviews</h6>
        </div>
      </div>
    </div>
  );
};

export default AdvisorReviewsCard;
